import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQ = () => {
  const faqs = [{
    question: 'How does the 30-day payment term work?',
    answer: 'When you submit a bill through Settl, we pay your vendor immediately. You then have 30 days to pay us back the full amount. We send a consolidated statement on the 1st of each month for all bills paid in the previous month, with payment due on the 15th.'
  }, {
    question: 'Is there a limit to how many bills I can process?',
    answer: 'Each pricing plan comes with a different bill limit. The Starter plan includes up to 15 bills per month, Growth includes up to 50, and Enterprise has unlimited bills. If you occasionally exceed your limit, we charge a small per-bill fee for the excess.'
  }, {
    question: 'What payment methods do you support for vendors?',
    answer: 'We support all major payment methods in Malaysia including FPX, bank transfers (GIRO/IBG/RENTAS), credit cards, and even international wire transfers. We can also accommodate check payments for vendors who require them.'
  }, {
    question: 'How do I submit bills to Settl?',
    answer: "You can submit bills through our web portal, by email to bills@settl.my, via our WhatsApp business account, or through our API if you're on the Enterprise plan. We also offer auto-forwarding setup where vendors can send invoices directly to your dedicated Settl email address."
  }, {
    question: 'Is my data secure with Settl?',
    answer: 'Absolutely. We use bank-level encryption for all data storage and transmission. Our platform is compliant with Malaysian financial regulations, and we implement strict access controls. We never share your data with third parties without your explicit permission.'
  }, {
    question: 'Can Settl integrate with my accounting software?',
    answer: 'Yes, we integrate with popular accounting software used in Malaysia including QuickBooks, Xero, and SQL Accounting. Our Enterprise plan also offers API access for custom integrations with your ERP or other financial systems.'
  }, {
    question: "What happens if I don't pay Settl within 30 days?",
    answer: 'We understand cash flow challenges happen. If you need more time, please contact us before the due date. Late payments may incur a fee of 2% of the outstanding amount. Consistently late payments might affect your credit terms with us.'
  }, {
    question: 'Is there a setup fee or long-term contract?',
    answer: "There's no setup fee, and our service operates on a month-to-month basis with no long-term commitment required. You can upgrade, downgrade, or cancel at any time. We're confident you'll love the service enough to stay!"
  }];
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? null : index);
  };
  // Split FAQs into two columns for desktop
  const leftFAQs = faqs.slice(0, Math.ceil(faqs.length / 2));
  const rightFAQs = faqs.slice(Math.ceil(faqs.length / 2));
  const renderFAQs = (faqList, startIndex = 0) => <div className="space-y-4" data-id="element-19">
      {faqList.map((faq, index) => {
      const actualIndex = startIndex + index;
      return <div key={actualIndex} className="border-b border-gray-200 pb-4 last:border-b-0" data-id="element-20">
            <button onClick={() => toggleFAQ(actualIndex)} className="flex justify-between items-center w-full text-left py-2 focus:outline-none" data-id="element-21">
              <span className="font-medium" data-id="element-22">{faq.question}</span>
              {openIndex === actualIndex ? <ChevronUp className="h-5 w-5 text-settl-blue" data-id="element-23" /> : <ChevronDown className="h-5 w-5 text-slate-grey" data-id="element-24" />}
            </button>
            {openIndex === actualIndex && <div className="mt-2 text-slate-grey text-sm" data-id="element-25">{faq.answer}</div>}
          </div>;
    })}
    </div>;
  return <section id="faq" className="section bg-light-sky" data-id="element-26">
      <div className="container" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="font-outfit font-bold text-3xl md:text-4xl mb-6" data-id="element-29">
            Frequently Asked Questions
          </h2>
          <p className="text-slate-grey text-lg max-w-3xl mx-auto" data-id="element-30">
            Got questions? We've got answers. If you don't see what you're
            looking for, reach out to our team.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-8" data-id="element-31">
          <div className="hidden md:grid md:grid-cols-2 gap-8" data-id="element-32">
            {renderFAQs(leftFAQs)}
            {renderFAQs(rightFAQs, leftFAQs.length)}
          </div>
          <div className="md:hidden" data-id="element-33">{renderFAQs(faqs)}</div>
        </div>
        <div className="text-center mt-8" data-id="element-34">
          <p className="text-slate-grey mb-4" data-id="element-35">Still have questions?</p>
          <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="btn-secondary" data-id="element-36">
            Contact Our Team
          </a>
        </div>
      </div>
    </section>;
};
export default FAQ;